const isBrowserEnv = () =>
  typeof window === "object" && typeof window.document === "object";

export default isBrowserEnv;



// WEBPACK FOOTER //
// ./src/utils/isBrowserEnv.js